import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { registerEventHandler } from './callbackUtil';
import eventKeys from './eventKeys';

const googleAnalytics = {
    baseLocation: '',
    linkerParam: '',
    initialized: false,
    pendingActions: []
};

// When components/layout/index.js is requested, "loadGoogleAnalyticsTracker" action is called
// to retrieve Google Analytics and Tag Manager configurations from server.
// "loadGoogleAnalyticsTracker" raises "GA_TRACKER_LOADED" event once the request is done.
// The following code block listens to that event, and performs initialization accordingly.
registerEventHandler(eventKeys.GA_TRACKER_LOADED, gaTracker => {
    googleAnalytics.baseLocation = `${window.location.protocol}//${window.location.hostname}`;

    // Initialize Google Analytics.
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/linker
    ReactGA.initialize(gaTracker.analyticsId, {
        gaOptions: {
            allowLinker: true
        }
    });

    // Initialize Google Tag Manager.
    TagManager.initialize({
        gtmId: gaTracker.tagManagerId
    });

    ReactGA.ga((tracker) => {
        googleAnalytics.linkerParam = tracker.get('linkerParam');
    });

    googleAnalytics.initialized = true;

    // Execute all pending actions.
    while (googleAnalytics.pendingActions.length > 0) {
        var pendingAction = googleAnalytics.pendingActions.shift();
        pendingAction();
    }
});

const runOrRegisterAction = action => {
    if (googleAnalytics.initialized) {
        action();
    }
    else {
        googleAnalytics.pendingActions.push(action);
    }
};

export const getLinkerParam = () => {
    return googleAnalytics.linkerParam;
};

export const setLocation = location => {
    runOrRegisterAction(() => ReactGA.set({ location: `${googleAnalytics.baseLocation}${location}` }));
};

export const raiseEvent = event => {
    runOrRegisterAction(() => ReactGA.event(event));
};


// WEBPACK FOOTER //
// ./src/utils/googleAnalyticsUtil.js